import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { Permissao, PermissoesApiService } from '@cei-ufg/ngx-cei-seguranca';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CeiButtonComponent, CeiPanelComponent } from '@cei-ufg/ngx-arquitetura-cei-frontend';

@Component({
  selector: 'cei-admin-permissao-detail',
  standalone: true,
  imports: [AdminPageCabecalhoComponent, CommonModule, RouterModule, CeiButtonComponent, CeiPanelComponent],
  templateUrl: './detail.component.html',
})
export class AdminPermissaoDetailComponent {
  protected readonly permissao = signal<Permissao | null>(null);
  private readonly permissoesApi = inject(PermissoesApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      const data = await firstValueFrom(
        this.permissoesApi.permissaoRetrieve({ id }, 'body', false, {
          transferCache: false,
        })
      );
      this.permissao.set(data);
    }
  }
}
